import React from "react";
import { useTranslation } from "react-i18next";
import {
  PassBooleanControl,
  PassSettingSwitch,
  PassSettingSwitchThumb,
} from "../companySettingsMobileView/companySystemSettings/passSettingsV2.styled";
import { SystemSettingRow } from "../companySettingsMobileView/companySystemSettings/systemSettingRow.component";

export const LocalStampClockSetting: React.FC<{
  value: boolean;
  onChange: (v: boolean) => void;
}> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <SystemSettingRow
      title={t("ProfileCompany.LocalStampClock")}
      description={t("ProfileCompany.LocalStampClockHelpText")}
      controlVerticalAlign="center"
    >
      <PassBooleanControl>
        <PassSettingSwitch
          type="button"
          $active={value}
          aria-label={t("ProfileCompany.LocalStampClock")}
          aria-pressed={value}
          onClick={() => onChange(!value)}
        >
          <PassSettingSwitchThumb $active={value} />
        </PassSettingSwitch>
      </PassBooleanControl>
    </SystemSettingRow>
  );
};
